import React, { useEffect, useState } from 'react';

// Live countdown to an ISO expiry. Calls onExpire once when it reaches zero.
export function Countdown({ expiresAt, onExpire, className = '' }: { expiresAt?: string | null; onExpire?: () => void; className?: string }) {
  const [left, setLeft] = useState<number>(() => (expiresAt ? new Date(expiresAt).getTime() - Date.now() : 0));

  useEffect(() => {
    if (!expiresAt) return;
    const target = new Date(expiresAt).getTime();
    const tick = () => {
      const ms = target - Date.now();
      setLeft(ms);
      if (ms <= 0 && onExpire) onExpire();
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expiresAt]);

  if (!expiresAt) return null;
  if (left <= 0) return <span data-testid="countdown-expired" className={`font-mono ${className}`}>00:00:00 (kedaluwarsa)</span>;

  const totalSec = Math.floor(left / 1000);
  const h = String(Math.floor(totalSec / 3600)).padStart(2, '0');
  const m = String(Math.floor((totalSec % 3600) / 60)).padStart(2, '0');
  const s = String(totalSec % 60).padStart(2, '0');
  return <span data-testid="countdown" className={`font-mono tabular-nums ${className}`}>{h}:{m}:{s}</span>;
}
